export function searchFilter(optionValue, inputValue) {
    return String(optionValue)
        .trim()
        .toLowerCase()
        .includes(String(inputValue)
        .trim()
        .toLowerCase());
}
//# sourceMappingURL=search-filter.js.map